import { useQuery } from "@tanstack/react-query";
import { getLatestHospitalityListing } from "../../api";

export const useGetLatestHospitalityListing = ({
  propertyUid,
}: {
  propertyUid: string;
}) => {
  const query = useQuery({
    queryKey: ["hospitality-listings", propertyUid],
    queryFn: () => getLatestHospitalityListing(propertyUid),
    enabled: !!propertyUid,
  });

  return { ...query, data: query.data?.data };
};
